import api from "./Api";

class ProdutoSimuladorService {
  GetProdutoSimulador(payload) {
    return api.get("/v1/produtoSimulador/" + payload).then((response) => {
      return response.data;
    });
  }

  PostProdutoSimulador(payload) {
    return api.post("/v1/produtoSimulador/", payload).then((response) => {
      return response.data;
    });
  }

  PutProdutoSimulador(payload) {
    return api.put("/v1/produtoSimulador/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteProdutoSimulador(payload) {
    return api.delete("/v1/produtoSimulador/" + payload).then((response) => {
      return response.data;
    });
  }

  GetProdutoSimuladorOData(payload) {
    return api.get("/OData/ProdutoSimulador" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ProdutoSimuladorService();
